var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('Footer'),_c('button',{staticClass:"global-service-btn",attrs:{"type":"button","aria-label":"service"},on:{"click":_vm.toService}},[_c('img',{attrs:{"src":require("./assets/img/kf.png"),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }